<template>
  <div>
    <div>Publicaciones por usuarios últimos 45 días:</div>
    <b-list-group>
      <b-list-group-item v-for="metric in newsFeedMetrics.created_by_count" :key="metric.created_by">
        {{ metric.concat }} <span class="float-right">{{ metric.occurrences }}</span>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
    import {trade} from '../../../../services/api/ExpertoRetail'
    import {onMounted, ref} from '@vue/composition-api'
    export default {
        name: "NewsFeedMetrics",
      setup (props, context) {
        const newsFeedMetrics = ref([])


        const getNewsFeedMetrics = async () => {
          try {
            newsFeedMetrics.value = await trade.newsFeedMetrics()
          } catch (e) {
            makeToast('Ha ocurrido un error generando datos', 'Error')
          }
        }

        onMounted(() => getNewsFeedMetrics())

          return { newsFeedMetrics }
      }
    }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/expertoRetail/views/trade/components/NewsFeedMetrics.vue